/**
 * Module dependencies.
 */

import React, { type ComponentPropsWithoutRef, type SyntheticEvent } from 'react';
import { cn } from 'app/lib/utils';

/**
 * Fallback to the placeholder icon when a coin image fails to load.
 */

function handleIconError(event: SyntheticEvent<HTMLImageElement>) {
  const img = event.currentTarget;

  if (img.dataset.fallback === 'true') {
    return;
  }

  img.dataset.fallback = 'true';
  img.src = '/api/crypto/icon/no_coin';
}

/**
 * Export `Icon` component.
 */

export function Icon({ alt = '', className, onError, ...rest }: ComponentPropsWithoutRef<'img'>) {
  return (
    <img alt={alt} className={cn('mr-2 h-[30px] w-[30px]', className)} onError={onError ?? handleIconError} {...rest} />
  );
}
